import React from "react";
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Paper,
    Divider,
} from "@mui/material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

const TopupPrint = ({ contentRef, formData }) => {
    return (
        <Box
            ref={contentRef}
            sx={{
                maxWidth: 650,
                margin: "40px auto",
                padding: 5,
                backgroundColor: "#ffffff",
                borderRadius: 3,
                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                fontFamily: "'Poppins', sans-serif",
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 3,
                    gap: 1,
                    color: "primary.main",
                }}
            >
                <ReceiptLongIcon sx={{ fontSize: 40 }} />
                <Typography variant="h4" sx={{ fontWeight: 800 }}>
                    Top-Up Receipt
                </Typography>
            </Box>

            {/* Subtitle */}
            <Typography
                variant="subtitle1"
                sx={{
                    textAlign: "center",
                    mb: 4,
                    color: "text.secondary",
                    fontWeight: 500,
                    letterSpacing: 0.5,
                }}
            >
                Transaction Details & Confirmation
            </Typography>

            {/* Data Table */}
            <TableContainer
                component={Paper}
                elevation={0}
                sx={{
                    borderRadius: 2,
                    border: "1px solid #e0e0e0",
                    overflow: "hidden",
                }}
            >
                <Table size="medium" aria-label="topup details table">
                    <TableBody>
                        {[
                            { label: "Property", value: formData?.PropName },
                            { label: "Booking No", value: formData?.BookNo },
                            { label: "Resident", value: formData?.ResidentName },
                            { label: "Room Type", value: formData?.RoomTypeName },
                            { label: "Bed No", value: formData?.RoombedName },
                            { label: "Top-Up Days", value: formData?.TopUpDays },
                            {
                                label: "Top-Up Amount",
                                value:
                                    formData?.TopUpAmt !== undefined
                                        ? `₹${Number(formData.TopUpAmt).toFixed(2)}`
                                        : "-",
                                highlight: false,
                            },
                            { label: "Payment Advice No", value: formData?.PytAdvNo },
                            { label: "Remark", value: formData?.Remark },
                        ].map(({ label, value, highlight }) => (
                            <TableRow
                                key={label}
                                sx={{
                                    backgroundColor: highlight ? "primary.light" : "transparent",
                                    "&:last-child td": { borderBottom: 0 },
                                }}
                            >
                                <TableCell
                                    sx={{
                                        fontWeight: 700,
                                        textTransform: "uppercase",
                                        fontSize: "0.85rem",
                                        color: highlight ? "primary.main" : "text.secondary",
                                        width: "45%",
                                        borderRight: "1px solid #e0e0e0",
                                        backgroundColor: highlight ? "#E3F2FD" : "#fafafa",
                                        verticalAlign: "middle",
                                    }}
                                >
                                    {label}
                                </TableCell>
                                <TableCell
                                    sx={{
                                        fontWeight: highlight ? 800 : 600,
                                        fontSize: highlight ? "1.1rem" : "0.95rem",
                                        color: highlight ? "primary.dark" : "text.primary",
                                        verticalAlign: "middle",
                                    }}
                                >
                                    {value || "-"}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Footer */}
            <Typography
                variant="body2"
                sx={{
                    textAlign: "center",
                    color: "text.secondary",
                    fontStyle: "italic",
                    letterSpacing: 0.4,
                    userSelect: "none",
                }}
            >
                Thank you for your payment. For any inquiries, please contact management.
            </Typography>
        </Box>
    );
};

export default TopupPrint;
